const AboutUs = () => {
  return (
    <div className="profile">
      <div className="d-flex align-items-center flex-column">
        {/* <img
          className="img-fluid rounded my-4"
          src="/assets/img/elements/main-logo.png"
          width="310"
          alt="User avatar"
        /> */}
        <h4>سامانه مدیریت خانه هوشمند</h4>
        <div className="user-info text-center">
          <h5 className="mb-2">
            <span>IBMS_Group</span>
            <img src="/assets/img/elements/copyright.png" width="20" alt="" />
          </h5>
          <p><i>Version 2.0</i></p>
          {/* <span className="badge bg-label-secondary">91312345678</span> */}
        </div>
        
      </div>
    </div>
  );
};

export default AboutUs;
